import {
  Segmented,
  Typography,
} from "antd";
import { useState } from "react";
import { TITLE_TXT } from "../../constants/constants";
import "./Settlement.scss"
import SettlementTable from "./Components/SettlementTable";

const { Title } = Typography;

const settleSegments = [
  {
    label: 'Unassigned Transactions',
    value: 'unassignTrans'
  },
];

const Settlement = () => {
  const [selectedTab, setSelectedTab] = useState('unassignTrans');

  return (
    <div className="settlement-container">
      <Title level={3} style={{ fontSize: 24 }}>
        {TITLE_TXT.SETTLEMENT}
      </Title>
      <div className="segmented-wrapper">
        <Segmented
          options={settleSegments}
          value={selectedTab}
          onChange={(value) => setSelectedTab(value)}
          className="custom-segmented"
        />
      </div>
      <SettlementTable selectedTab={selectedTab} />
    </div>
  )
}

export default Settlement